module.exports = __webpack_public_path__ + "img/logo-small.61fcbdbe.png";